import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import "./i18nextInit";
import './i18nextConf';

ReactDOM.render(
	React.createElement(App),
	document.getElementById('root')
);
